import Papers from "./papers/Papers";
import Banner from "./Banner";
import "./Display.css";

const Home = () => {
  return (
    <div className="homeContainer">
      <Banner />
      <div className="creditContainer">
      </div>
      <div className="labCardContainer">
        <div className="pageBlurb">
          <h1 className="welcomeHead">Welcome to the ACDS Paper Finder</h1>
        </div>
        <p className="infoBlurb">
        The Australasian Cell Death Society (ACDS) paper finder is a resource designed to make searching the local cell death literature easy. This resource can be used as a historical reference point for publications made by Australasian cell death researchers, or as a way to stay updated with the recent findings of the Australasian cell death community. You may also use the ACDS paper finder to discover the latest cell death publications from around the world using the country selection bar. Each returned listing has at least one author with affiliations from Institutes or Universities in the country selected.
        </p>
        <Papers />
      </div>
    </div>
  );
};

export default Home;
